import Button from '@/presentation/components/elements/Button';
import Icon, { Icons } from '@/presentation/components/elements/Icon';

import ellipsis from '@/presentation/utils/ellipsis';

import { Transaction } from 'nftx.js';
import { useTranslations } from 'use-intl';
import { Chain } from 'viem';

const MigrateVTokenSuccess = ({
  transaction,
  chain,
  onClose,
}: {
  transaction?: Transaction;
  chain: Chain;
  onClose: () => void;
}) => {
  const t = useTranslations('Migrate.Success');
  const txHash = transaction?.hash;

  return (
    <div className="p-6 bg-gray-50 max-w-lg mx-auto">
      <h2 className="text-lg text-center mb-2 font-bold">{t('title')}</h2>
      <div className="p-4 flex justify-center items-center">
        <Icon name={Icons.CHECK} size={48} className="text-green-500" />
      </div>
      <p className="text-center mb-8">
        <a
          href={`${chain.blockExplorers?.default.url}/tx/${txHash}`}
          className="inline-flex items-center hover:underline"
          target="_blank"
          rel="nofollow noreferrer"
        >
          {t('tx', { hash: ellipsis(txHash) })}
          <Icon name={Icons.EXTERNAL} size={12} className="ml-1" />
        </a>
      </p>

      {/* <section className="rounded-md bg-gray-100 border border-gray-300 divide-y divide-gray-300">
        <h3 className="p-4 text-center font-medium">
          {'Not sure what to do next?'}
        </h3>
        <ul className="divide-y divide-gray-300">
          <li className="p-4 flex justify-between">
            <div>
              <h4>{`View positions`}</h4>
            </div>
            <button>{'Add'}</button>
          </li>
          <li className="p-4 flex justify-between">
            <div>
              <h4>{`Deposit vault`}</h4>
              <span className="bg-gray-500 text-gray-50 text-xs rounded-md py-0.5 px-1 inline-block mr-2">
                {'Earns vault fees'}
              </span>
            </div>
            <button className="underline hover:no-underline font-bold">
              {'Stake'}
            </button>
          </li>
          <li className="p-4 flex justify-between">
            <div>
              <h4>{`Migrate more`}</h4>
            </div>
            <button
              onClick={() => {}}
              className="underline hover:no-underline font-bold"
            >
              {'LP'}
            </button>
          </li>
        </ul>
      </section> */}

      <div className="mt-4 flex justify-center">
        <Button type="button" variant="primary" onClick={onClose}>
          {'Close'}
        </Button>
      </div>
    </div>
  );
};

export default MigrateVTokenSuccess;
